import {
    PERITADOR_ACT_REPORT_FILE_BEGIN,
    PERITADOR_ACT_REPORT_FILE_SUCCESS,
    PERITADOR_ACT_REPORT_FILE_FAILURE,
    PERITADOR_ACT_REPORT_FILE_DISMISS_ERROR,
  } from './constants';
  import axios from "axios";
  import {REACT_APP_API} from '../../../common/config';

export function reportPeritador(args = {}) {
    return async (dispatch) => { // optionally you can have getState as the second argument
        dispatch({
            type: PERITADOR_ACT_REPORT_FILE_BEGIN,
        });
        try {
            const res = await axios(`${REACT_APP_API}/api/report/excel?desde=${args.from}&hasta=${args.to}`, {
                method: 'GET',
                timeout: 300000, // 5 minutos
            })

            // TODO: maybe generate a helper function
            const link = document.createElement('a');
            link.href = res.data.downloadUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch({
                type: PERITADOR_ACT_REPORT_FILE_SUCCESS,
                data: res,
            });
            return res;
        } catch (err) {
            dispatch({
                type: PERITADOR_ACT_REPORT_FILE_FAILURE,
                data: { error: err },
            });
            return Promise.reject(err);
        }
    };
}
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissReportPeritadorError() {
    return {
      type: PERITADOR_ACT_REPORT_FILE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PERITADOR_ACT_REPORT_FILE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          reportPeritadorPending: true,
          reportPeritadorError: null,
        };
  
      case PERITADOR_ACT_REPORT_FILE_SUCCESS:
        // The request is success
        return {
          ...state,
          reportPeritadorPending: false,
          reportPeritadorError: null,
        };
  
      case PERITADOR_ACT_REPORT_FILE_FAILURE:
        // The request is failed
        return {
          ...state,
          reportPeritadorPending: false,
          reportPeritadorError: action.data.error,
        };
  
      case PERITADOR_ACT_REPORT_FILE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          reportPeritadorError: null,
        };
  
      default:
        return state;
    }
  }
  
